(ns teamoesterreich.user-mode.warnings.warning-helper
  (:require [clojure.string]
            ))





(defn warning-image [w-type w-level]
  (cond

    (and (= w-type "zamg_1") (< w-level 3)) "/svg/wind_yellow.svg"
    (and (= w-type "zamg_1") (< w-level 5)) "/svg/wind_orange.svg"
    (and (= w-type "zamg_1") (= w-level 5)) "/svg/wind_red.svg"

    (and (= w-type "zamg_2") (< w-level 3)) "/svg/pouring_yellow.svg"
    (and (= w-type "zamg_2") (< w-level 5)) "/svg/pouring_orange.svg"
    (and (= w-type "zamg_2") (= w-level 5)) "/svg/pouring_red.svg"

    (and (= w-type "zamg_3") (< w-level 3)) "/svg/snow_yellow.svg"
    (and (= w-type "zamg_3") (< w-level 5)) "/svg/snow_orange.svg"
    (and (= w-type "zamg_3") (= w-level 5)) "/svg/snow_red.svg"

    (and (= w-type "zamg_4") (< w-level 3)) "/svg/ice_yellow.svg"
    (and (= w-type "zamg_4") (< w-level 5)) "/svg/ice_orange.svg"
    (and (= w-type "zamg_4") (= w-level 5)) "/svg/ice_red.svg"

    (and (= w-type "zamg_5") (< w-level 3)) "/svg/lightning_yellow.svg"
    (and (= w-type "zamg_5") (< w-level 5)) "/svg/lightning_orange.svg"
    (and (= w-type "zamg_5") (= w-level 5)) "/svg/lightning_red.svg"

    (and (= w-type "zamg_6") (< w-level 3)) "/svg/heat_yellow.svg"
    (and (= w-type "zamg_6") (< w-level 5)) "/svg/heat_orange.svg"
    (and (= w-type "zamg_6") (= w-level 5)) "/svg/heat_red.svg"

    (and (= w-type "zamg_7") (< w-level 3)) "/svg/cold_yellow.svg"
    (and (= w-type "zamg_7") (< w-level 5)) "/svg/cold_orange.svg"
    (and (= w-type "zamg_7") (= w-level 5)) "/svg/cold_red.svg"



    (and (= w-type "DWD_WIND") (< w-level 3)) "/svg/wind_yellow.svg"
    (and (= w-type "DWD_WIND") (< w-level 5)) "/svg/wind_orange.svg"
    (and (= w-type "DWD_WIND") (= w-level 5)) "/svg/wind_red.svg"

    (and (= w-type "DWD_RAIN") (< w-level 3)) "/svg/pouring_yellow.svg"
    (and (= w-type "DWD_RAIN") (< w-level 5)) "/svg/pouring_orange.svg"
    (and (= w-type "DWD_RAIN") (= w-level 5)) "/svg/pouring_red.svg"

    (and (= w-type "DWD_HAIL") (< w-level 3)) "/svg/pouring_yellow.svg"
    (and (= w-type "DWD_HAIL") (< w-level 5)) "/svg/pouring_orange.svg"
    (and (= w-type "DWD_HAIL") (= w-level 5)) "/svg/pouring_red.svg"

    (and (= w-type "DWD_SNOWFALL") (< w-level 3)) "/svg/snow_yellow.svg"
    (and (= w-type "DWD_SNOWFALL") (< w-level 5)) "/svg/snow_orange.svg"
    (and (= w-type "DWD_SNOWFALL") (= w-level 5)) "/svg/snow_red.svg"

    (and (= w-type "DWD_SNOWDRIFT") (< w-level 3)) "/svg/snow_yellow.svg"
    (and (= w-type "DWD_SNOWDRIFT") (< w-level 5)) "/svg/snow_orange.svg"
    (and (= w-type "DWD_SNOWDRIFT") (= w-level 5)) "/svg/snow_red.svg"

    (and (= w-type "DWD_GLAZE") (< w-level 3)) "/svg/ice_yellow.svg"
    (and (= w-type "DWD_GLAZE") (< w-level 5)) "/svg/ice_orange.svg"
    (and (= w-type "DWD_GLAZE") (= w-level 5)) "/svg/ice_red.svg"

    (and (= w-type "DWD_THUNDERSTORM") (< w-level 3)) "/svg/lightning_yellow.svg"
    (and (= w-type "DWD_THUNDERSTORM") (< w-level 5)) "/svg/lightning_orange.svg"
    (and (= w-type "DWD_THUNDERSTORM") (= w-level 5)) "/svg/lightning_red.svg"

    (and (= w-type "DWD_HEAT") (< w-level 3)) "/svg/heat_yellow.svg"
    (and (= w-type "DWD_HEAT") (< w-level 5)) "/svg/heat_orange.svg"
    (and (= w-type "DWD_HEAT") (= w-level 5)) "/svg/heat_red.svg"

    (and (= w-type "DWD_UV") (< w-level 3)) "/svg/heat_yellow.svg"
    (and (= w-type "DWD_UV") (< w-level 5)) "/svg/heat_orange.svg"
    (and (= w-type "DWD_UV") (= w-level 5)) "/svg/heat_red.svg"

    (and (= w-type "DWD_FROST") (< w-level 3)) "/svg/cold_yellow.svg"
    (and (= w-type "DWD_FROST") (< w-level 5)) "/svg/cold_orange.svg"
    (and (= w-type "DWD_FROST") (= w-level 5)) "/svg/cold_red.svg"


    (< w-level 3) "/svg/warning_outline_yellow.svg"
    (< w-level 5) "/svg/warning_outline_orange.svg"
    :else "/svg/warning_outline_red.svg"
    ))

(defn level-name [w-type w-level]
  (let [dwd-level {1 "Stufe 1"
                   2 "Stufe 2"
                   3 "Stufe 3"
                   4 "Stufe 3"
                   5 "Stufe 4"}
        zamg-level {1 "GELB Vorsicht!"
                    3 "ORANGE Achtung!!"
                    5 "ROT Gefahr!!!"}]
    (str (cond
           (= w-type "DWD_WIND") (dwd-level w-level)
           (= w-type "DWD_RAIN") (get dwd-level w-level)
           (= w-type "DWD_SNOWFALL") (get dwd-level w-level)
           (= w-type "DWD_GLAZE") (get dwd-level w-level)
           (= w-type "DWD_HEAT") (get dwd-level w-level)
           (= w-type "DWD_THUNDERSTORM") (get dwd-level w-level)
           (= w-type "DWD_FROST") (get dwd-level w-level)
           (= w-type "DWD_TORNADO") (get dwd-level w-level)
           (= w-type "DWD_HAIL") (get dwd-level w-level)
           (= w-type "DWD_SNOWDRIFT") (get dwd-level w-level)
           (= w-type "DWD_THAW") (get dwd-level w-level)
           (= w-type "DWD_FOG") (get dwd-level w-level)
           (= w-type "DWD_UV") (get dwd-level w-level)
           (= w-type "oerk") (get dwd-level w-level)
           (= w-type "civil") (get dwd-level w-level)
           (= w-type "civil_warn") (get dwd-level w-level)
           (= w-type "civil_allclear") (get dwd-level w-level)

           (= w-type "zamg_1") (get zamg-level w-level)
           (= w-type "zamg_2") (get zamg-level w-level)
           (= w-type "zamg_3") (get zamg-level w-level)
           (= w-type "zamg_4") (get zamg-level w-level)
           (= w-type "zamg_5") (get zamg-level w-level)
           (= w-type "zamg_6") (get zamg-level w-level)
           (= w-type "zamg_7") (get zamg-level w-level)
           :else ""
           ))))

(defn warning-color [w-type w-level]
  (cond
    (>= w-level 4) "#ff0000"
    (>= w-level 2) "#ffcc00"
    (>= w-level 1) "#e0e025"
    :else "#ffffff"
    ))


(defn warning-name [w-type w-level]
  ;(log/debug "warning-name " w-type (= w-type "zamg_5"))
  (str (cond
         (= w-type "DWD_WIND") "Windböen"
         (= w-type "DWD_RAIN") "Starkregen"
         (= w-type "DWD_SNOWFALL") "Schneefall"
         (= w-type "DWD_GLAZE") "Glatteis"
         (= w-type "DWD_HEAT") "Gewitter"
         (= w-type "DWD_THUNDERSTORM") "Hitze"
         (= w-type "DWD_FROST") "Frost"
         (= w-type "DWD_TORNADO") "Orkanböen"
         (= w-type "DWD_HAIL") "Hagel"
         (= w-type "DWD_SNOWDRIFT") "Schneeverwehungen"
         (= w-type "DWD_THAW") "Tauwetter"
         (= w-type "DWD_FOG") "Nebel"
         (= w-type "DWD_UV") "UV Warnung"
         (= w-type "oerk") "Sonstige"

         (= w-type "zamg_1") "Starker Wind"
         (= w-type "zamg_2") "Starker Regen"
         (= w-type "zamg_3") "Schneefall"
         (= w-type "zamg_4") "Glatteis"
         (= w-type "zamg_5") "Gewitter"
         (= w-type "zamg_6") "Hitzebelastung"
         (= w-type "zamg_7") "Kältestress"
         :else "Allgemeine Warnung"
         )
       "  " (level-name w-type w-level)))


